import React from 'react';
import { DateField } from 'framework/ui/field';
import { POSITION_STATUS, RECRUITING_VACANCY_APPROVE_VACANCY, VACANCY_STATUS } from 'domain/shared/newVacancy';
import { useShowContext } from 'framework/show';
import ClosePositionButton from './closePosition/ClosePositionButton';
import { useAuthorization } from 'framework/authorization';
import { RECRUITING_CONTEXT } from 'domain/recruiting/RecruitingContext';

const VacancyCloseDateListField = ({ vacancyStatus, setGeneralContextData }: any) => {
  const { data } = useShowContext();
  const rowData = data.getData();
  const { isGranted } = useAuthorization();

  return (
    <>
      {rowData.status === POSITION_STATUS.OPEN &&
      vacancyStatus === VACANCY_STATUS.OPEN &&
      isGranted(RECRUITING_VACANCY_APPROVE_VACANCY, RECRUITING_CONTEXT) ? (
        <ClosePositionButton setGeneralContextData={setGeneralContextData} />
      ) : (
        <DateField source="closeDate" label="Close Date" />
      )}
    </>
  );
};

export default VacancyCloseDateListField;
